export default __webpack_public_path__ + "static/media/notification-button-arrow-blue.24831e95.svg";